export default {
    install(Vue) {
        Vue.prototype.$disableAudio = function () {
            document.querySelectorAll('audio').forEach(function (audio) {
                audio.pause();
            });
        };
    }
}